<template>
  <div class="container-fluid">
    <div class="row">
      <div
        class="col-12 mb-2"
        v-for="file in files"
        :key="file.id"
      >
        <div class="row align-items-center border-primary rounded-lg">
          <vs-icon
            class="col-1"
            icon="description"
            size="25px"
            color="primary"
          />
          <b class="w-100 text-center col-10">
            {{ file.name }}
          </b>
          <vs-button
            class="col-1"
            color="danger"
            type="flat"
            icon="clear"
            @click="removeFile(file.id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'file-list',
  props: {
    files: {
      type: Array,
      required: true,
    },
  },
  emits: ['remove-file'],
  methods: {
    removeFile(fileId) {
      this.$emit('remove-file', fileId);
    },
  },
};
</script>
